import Locations from "pages/Restaurant/Locations";

export default function LocationsPage() {
  return <Locations />;
}
